<template>
  <section
    id="cover"
    class="bg-white"
  >
    <div class="co-container-lg flex h-full flex-col items-center justify-center md:flex-row">
      <div class="hidden xl:block">
        <img
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Cover/cover-pc-man.webp"
          alt="女性の写真"
        >
      </div>
      <div class="grow bg-white px-5 py-10 text-center md:py-5">
        <img
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Cover/badge-gurantee.svg"
          alt="安全保障制度"
          class="mx-auto"
        >
        <h1 class="te-set-cover-h1 mb-3 font-bold leading-base">
          Webエンジニア転職保証コース
        </h1>
        <h2 class="co-display-12 mb-1 leading-base">
          <span class="block md:inline-block">未経験からWebエンジニアを目指す転職に特化したコース</span>
        </h2>
        <!-- 251202導線削除 -->
        <!-- <TeSetTimeSpanWhite :pack="pack" /> -->
        <div class="alert my-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
          お申し込みを停止しております。 再開の際には改めてご案内いたします。
        </div>
      </div>
      <div class="te-webdenginnerjobchange-cover-woman-bg">
        <img
          class="hidden md:block"
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Cover/cover-pc-woman.webp"
          alt="女性の写真"
        >
        <img
          class="block w-full md:hidden"
          src="~/assets/images/Te/TeSet/WebengineerJobchange/Cover/Triangle-shape.svg"
          alt="シェイプ"
        >
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import TeSetTimeSpanWhite from '~/components/Te/TeSet/TeSetTimeSpan/TeSetTimeSpanWhite.vue'

interface Props {
  pack: object
}

const options = {
  props: {
    pack: {
      default: null,
    },
  },
  components: {
    TeSetTimeSpanWhite,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-set-cover-h1 {
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
  @media (min-width: 992px) {
    font-size: 2rem;
  }
}

.te-webdenginnerjobchange-cover-woman-bg {
  width: 100%;
  height: 17.8125rem;
  background-image: url('~/assets/images/Te/TeSet/WebengineerJobchange/Cover/cover-sp-woman.webp');
  background-size: cover;
  @media (min-width: 576px) {
    height: 32.5rem;
    background-position: center;
  }
  @media (min-width: 768px) {
    width: auto;
    height: auto;
    background: none;
  }
}
</style>
